import { IUseState, UseService } from '@df/util/service/use.service';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable({
    providedIn: 'root'
})
export class BottomPanelService {
    constructor(private useService: UseService) {}

    private toGlobalId(id: string): string {
        return ['bottomPanel', id].join();
    }

    onShow(id: string, source: any): void {
        this.useService.lock(this.toGlobalId(id), source);
    }

    onHide(id: string, source: any): void {
        this.useService.unlock(this.toGlobalId(id), source);
    }

    observe(id: string): BehaviorSubject<boolean> {
        return this.getState(id).obs;
    }

    getState(id: string): IUseState {
        return this.useService.getState(this.toGlobalId(id));
    }
}
